import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Contexts/AuthContext/AuthProvider';

function getCookie(name) {
    const cookieValue = document.cookie.match(
        `(^|;)\\s*${name}\\s*=\\s*([^;]+)`
    );
    return cookieValue ? cookieValue.pop() : "";
}

const UserMobilePrivateRoute = ({ children }) => {

    // const { token, authUser, loading } = useContext(AuthContext);
    const location = useLocation();
    const [token, setToken] = useState(getCookie('WFL_token'));


    // const [userData, setUserdata] = useState([]);
    // const [loading, setLoading] = useState(true);


    // useEffect(() => {
    //     if (!authId) {
    //         SignOut();
    //         setLoading(false);
    //         return;
    //     }

    //     fetch(
    //         `https://api.wlfmobile.com/api/user/auth/${authId?.user_id}?deviceId=${authId?.deviceId}`,
    //         {
    //             method: "GET",
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         }
    //     )
    //         .then((res) => res.json())
    //         .then((data) => {
    //             if (!data?.success) {
    //                 SignOut();
    //                 return;
    //             }
    //             setUserdata(data)
    //         })
    //         .catch((err) => {
    //             SignOut();
    //             // console.error(err);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }, [authId]);




    // if (loading) {
    //     return <></>;
    // }

    if (!token) {
        return <Navigate to='/' sate={{ from: location }} replace ></Navigate>

    } else {
        if (token) {
            return children;
        } else {
            <Navigate to='*' sate={{ from: location }} replace></Navigate>
        }
    }



}

export default UserMobilePrivateRoute;